import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7850_501801)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M104 60C104 35.6995 84.3005 16 60 16C35.6995 16 16 35.6995 16 60C16 84.3005 35.6995 104 60 104C84.3005 104 104 84.3005 104 60ZM106 60C106 85.4051 85.4051 106 60 106C34.5949 106 14 85.4051 14 60C14 34.5949 34.5949 14 60 14C85.4051 14 106 34.5949 106 60Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61 56.25L61 82.5C61 83.0523 60.5523 83.5 60 83.5C59.4477 83.5 59 83.0523 59 82.5L59 56.25C59 55.6977 59.4477 55.25 60 55.25C60.5523 55.25 61 55.6977 61 56.25Z",
				fill: "url(#paint0_linear_7850_501801)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60 41.4365C61.1046 41.4365 62 42.332 62 43.4365C62 44.5411 61.1046 45.4365 60 45.4365C58.8954 45.4365 58 44.5411 58 43.4365C58 42.332 58.8954 41.4365 60 41.4365Z",
				fill: "url(#paint1_linear_7850_501801)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7850_501801",
			x1: 58,
			y1: 83.5,
			x2: 63.0136,
			y2: 83.3788,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E45D96"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7850_501801",
			x1: 58,
			y1: 83.5,
			x2: 63.0136,
			y2: 83.3788,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E45D96"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7850_501801",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 120,
				height: 120,
				fill: "white"
			})
		})
	] })]
});
export default SvgInfoBig;
